import { render, staticRenderFns } from "./KeywordList.vue?vue&type=template&id=5a415ffa&scoped=true&"
import script from "./KeywordList.vue?vue&type=script&lang=js&"
export * from "./KeywordList.vue?vue&type=script&lang=js&"
import style0 from "./KeywordList.vue?vue&type=style&index=0&id=5a415ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a415ffa",
  null
  
)

export default component.exports